import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Vehicle, VehicleRquest } from '../../services/http/vehicles/vehicles.interface';
import { AlertType } from '../../services/alert/alert.interface';
import { AlertService } from '../../services/alert/alert.service';
import { VehiclesService } from '../../services/http/vehicles/vehicles.service';
import { LoaderService } from '../../services/loader/loader.service';

@Component({
  selector: 'app-vehicle',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './vehicle.component.html',
  styleUrl: './vehicle.component.scss'
})
export class VehicleComponent {
  @Input() applicantId: string = '';
  @Output() goBackEvent = new EventEmitter<void>();
  @Output() goNewEvent = new EventEmitter<string>();

  vehicle: VehicleRquest = {
    vehiclePlate: '',
    vehicleAlias: '',
    ownerDeclaration: false
  }

  constructor(
    private readonly vehiclesService: VehiclesService,
    private readonly alertService: AlertService,
    private readonly loaderService: LoaderService
  ) {}

  create() {
    if (this.vehicle) {
      this.vehicle.vehiclePlate = this.vehicle.vehiclePlate.toUpperCase().replace(' ', '');
      this.loaderService.show();
      if (this.vehicle.vehiclePlate.length < 6) {
        this.alertService.setAlert({
          message: $localize`:@@Vehicles.Create.InvalidPlate:La matrícula debe tener al menos 6 caracteres`,
          type: AlertType.Error,
          dismissible: true,
          dismissOnTimeout: 5000
        });
        this.loaderService.hide();
        return;
      }
      this.vehiclesService.addVehicle(this.vehicle).subscribe({
        next: (newVehicle: Vehicle) => {
          this.alertService.setAlert({
            message: $localize`:@@Vehicles.Create.Created:Vehículo creado correctamente`,
            type: AlertType.Success,
            dismissible: true,
            dismissOnTimeout: 5000
          });
          this.loaderService.hide();
          this.goNewEvent.emit(newVehicle.vehiclePlate);
        }
      });
    }
  }

  goBack() {
    this.goBackEvent.emit();
  }
}
